<div class="row vehicle-info-container">
  @if ((vehicle$ | async); as vehicle) {
    <div>
      @if (!component.primary?.verify_form) {
        <div tabindex="0" role="heading" aria-live="assertive" [ngStyle]="getVehicleStyle(component)" class="vehicle-component"
          >
          <div class="vehicle-information">@if (component.primary?.year) {
            <span> {{vehicle?.year}}</span>
            }@if (component.primary?.make) {
            <span>
            {{vehicle?.make}}</span>
            } @if (component.primary?.model) {
            <span> {{vehicle?.model}}</span>
          }
        </div>
        @if (component.primary?.vin) {
          <div><strong> {{ 'ASP_LANDING.VIN' | translate }} {{ maskVin(vehicle?.vin)}}</strong></div>
        }
      </div>
    }
  </div>
}

@if (component.primary?.verify_form) {
  <app-verify-vehicle class="verify_form" [ngStyle]="getStyles(component)"
  [verifyVehicleData]="component.primary"></app-verify-vehicle>
}
</div>